import { useApi } from "./useAppGlobals";

export interface User {
  id: string;
  username: string;
  email: string;
  display_name: string | null;
  role: string;
  is_active: boolean;
  is_reset?: boolean;
}

export interface CreateUserData {
  username: string;
  email: string;
  display_name: string;
  password: string;
}

export interface ListUsersResponse {
  total: number;
  page: number;
  users: User[];
}

export interface CreateUserResponse {
  id: string;
  username: string;
  email: string;
  display_name: string;
  role: string;
}

export interface ChangePasswordResponse {
  id: string;
  username: string;
  temp_password: string;
}

export interface ResetPasswordResponse {
  success: boolean;
  token: string;
  is_reset: boolean;
}

export interface LoginResponse {
  id: string;
  name: string;
  token: string;
  users: string[];
  role: string;
  is_reset: boolean;
}

export const useUserApi = () => {
  const api = useApi();

  return {
    async listUsers(
      search?: string,
      page: number = 0
    ): Promise<ListUsersResponse> {
      const params = new URLSearchParams();
      if (search) params.append("search", search);
      params.append("page", String(page));

      const response = await api.instance.get<ListUsersResponse>(
        `/api/users/list?${params.toString()}`
      );
      return response.data;
    },

    async createUser(data: CreateUserData): Promise<CreateUserResponse> {
      const response = await api.instance.post<CreateUserResponse>(
        "/api/users/create",
        data
      );
      return response.data;
    },

    async updateUserStatus(
      userId: string,
      isActive: boolean
    ): Promise<User> {
      const response = await api.instance.patch<User>(
        `/api/users/${userId}/status`,
        { is_active: isActive }
      );
      return response.data;
    },

    async changeUserPassword(userId: string, newPassword: string): Promise<ChangePasswordResponse> {
      const response = await api.instance.patch<ChangePasswordResponse>(
        `/api/users/${userId}/password`,
        { password: newPassword }
      );
      return response.data;
    },

    async resetPassword(newPassword: string): Promise<ResetPasswordResponse> {
      const response = await api.instance.post<ResetPasswordResponse>(
        "/login/reset-password",
        { new_password: newPassword }
      );
      return response.data;
    },
  };
};
